import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/HeroSection.css";

/* Images */
import heroImg from "../../assets/img/new-dev/hero-dental.png";
import pluginIcon from "../../assets/img/new-dev/icon-plugin.png";
import BuiltinIcon from "../../assets/img/new-dev/ModernIcon.png";
import securityIcon from "../../assets/img/new-dev/icon-security.png";
import monetizeIcon from "../../assets/img/new-dev/icon-monetize.png";
import ComplianceIcon from "../../assets/img/new-dev/ComplianceIcon.png";
import ModernIcon from "../../assets/img/new-dev/icon-workflows.png";

/* How it works */
import curveLine from "../../assets/img/new-dev/how-it-works-path.png";
import dotImg from "../../assets/img/new-dev/step-dot.png";
import bannerImg from "../../assets/img/new-dev/CommunityTestimonials.png";
import sdkImg from "../../assets/img/new-dev/sdk-dashboard.png";
/* ================= DATA ================= */
import heroAppImg from "../../assets/img/new-dev/marketplace-preview.png";

/* Icons */
import calendarIcon from "../../assets/img/new-dev/icon-calendar.png";
import shieldIcon from "../../assets/img/new-dev/icon-shield.png";
import apiIcon from "../../assets/img/new-dev/icon-calendar.png";

const devGoalsData = {
  title: "High-Priority Development Goals",
  goals: [
    {
      icon: calendarIcon,
      text: "Publish in days, not months"
    },
    {
      icon: shieldIcon,
      text: "Complete auth & order management"
    },
    {
      icon: apiIcon,
      text: "Built-in open APIs"
    }
  ]
};
const testimonials = [
  {
    name: "Dr. Sarah Chen",
    role: "General Dentist, Chen Dental Care",
    text:
      "The AI diagnostic assistant has transformed how we analyze X-rays. We can now provide faster, more accurate diagnoses, which our patients really appreciate."
  },
  { name: "Dr. Michael Ross", role: "Oral Surgeon", text: "Dentulu’s AI tools significantly reduced our documentation time and improved consistency.", }, { name: "Emily Carter", role: "Practice Manager", text: "Scheduling automation alone has improved patient flow and reduced no-shows.", }, { name: "James Patel", role: "Dental Developer", text: "The API integrations are clean, scalable, and well-documented.", }, { name: "Sophia Martinez", role: "Orthodontist", text: "Treatment planning has never been this efficient and visual.", }, { name: "Daniel Kim", role: "Dental Consultant", text: "AI-powered insights help clinics grow with confidence.", }];

export const dentalAppsData = { title: "Build, Launch & Monetize", subtitle: "HIPAA-Compliant Dental Apps", description: "Dentulu gives you everything you need to go from idea to revenue modern APIs, SDKs, webhooks, and compliance built in. Publish HIPAA-aware apps to Dentulu’s marketplace, plug into dental clinics worldwide, and unlock new revenue streams with ready-made workflows, secure integrations, and global deployment support.", buttons: [{ label: "Start Building on Dentulu", type: "primary" }, { label: "View Docs", type: "secondary" }], features: [{ icon: pluginIcon, title: "Plug into Dentulu Clinics & Apps", text: "Publish HIPAA-aware apps to Dentulu's marketplace and reach dental practices and patients instantly." }, { icon: ModernIcon, title: "Modern APIs & Webhooks", text: "FastAPI backend with secure API keys, JWT authentication, event webhooks, HMAC signing, and detailed delivery logs." }, { icon: securityIcon, title: "Security & Compliance", text: "SOC 2-ready practices, audit trails, RBAC, encryption at rest/in transit, and PHI isolation by design." }, { icon: BuiltinIcon, title: "Built-in Workflows", text: "Patient onboarding, orders, scheduling, payments, and messaging primitives so you ship faster." }, { icon: monetizeIcon, title: "Monetize Your Way", text: "Charge one-time, usage-based, or subscription models. Stripe-native checkout with automatic license provisioning." }, { icon: ComplianceIcon, title: "Global Compliance & Scale", text: "Multi-region infrastructure with localization hooks and data segregation for US/EU/India rollouts." }] };

export const stepsData = [{ id: 1, position: "step-one", title: "Create a Developer Account", description: "Sign up, verify identity, and grab your staging API keys." }, { id: 2, position: "step-two", title: "Build with Our SDKs & Docs", description: "Use REST endpoints, webhooks, and example apps to integrate quickly." }, { id: 3, position: "step-three", title: "List on the Marketplace", description: "Submit for review, set pricing, and go live to Dentulu’s provider and patient networks." }];

/* ================= COMPONENT ================= */
export const sdkData = {
  title: "SDKs & Examples",
  subtitle:
    "Build, test, and debug confidently. Dentulu’s SDKs and tools provide a complete environment for faster integration and local experimentation.",
  image: sdkImg,
  badges: [
    "Save Development Time",
    "Build Once Deploy Everywhere"
  ],
  features: [
    {
      id: 1,
      title: "Local-First Dev Flow",
      description:
        "Helpers, webhook verifiers, and starter apps to accelerate integration."
    },
    {
      id: 2,
      title: "Complete SDKs",
      description:
        "Full-featured libraries for different coding languages."
    },
    {
      id: 3,
      title: "Observability",
      description:
        "Request logs, webhook retries, and status dashboards to debug faster."
    }
  ]
};
const DentalApps = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setActive((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
  };

  const stopAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, []);

  return (
    <>


      {/* ================= HERO ================= */}
      <section class="eco-dev-bg-main">
        <section className="marketplace-hero">
          <div className="container marketplace-grid">

            {/* LEFT CONTENT */}
            <div className="marketplace-content">
              <h1 className="hero-title">
                Build, Launch & Monetize Dental
                <span> Apps on Dentulu</span>
              </h1>

              <p className="hero-subtitle">
                A developer-first platform to integrate AI, imaging, payments,
                and workflows then list your app to thousands of providers and
                patients.
              </p>

              <button className="hero-cta" onClick={() => navigate('/signup')}>
                Get started for free
              </button>
            </div>

            {/* RIGHT IMAGE */}
            <div className="marketplace-image">
              <img src={heroAppImg} alt="Dentulu Marketplace Apps" />
            </div>

          </div>
        </section>
        <section className="devgoals-section">
          <div className="container devgoals-wrapper">

            {/* LEFT TITLE */}
            <h3 className="devgoals-title">
              {devGoalsData.title}
            </h3>

            {/* RIGHT GOALS */}
            <div className="devgoals-items">
              {devGoalsData.goals.map((item, index) => (
                <div
                  key={index}
                  className="devgoals-item"
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <img src={item.icon} alt="" />
                  <span>{item.text}</span>
                </div>
              ))}
            </div>

          </div>
        </section>
        <section className="dental-apps">
          <div className="container">
            <div className="apps-grid">
              <div className="apps-image">
                <img src={heroImg} alt="Dental App Development" />
              </div>

              <div className="apps-content">
                <h2>
                  {dentalAppsData.title}
                  <span> {dentalAppsData.subtitle}</span>
                </h2>
                <p>{dentalAppsData.description}</p>

                <div className="apps-actions">
                  {dentalAppsData.buttons.map((btn, i) => (
                    <button
                      key={i}
                      className={`btn ${btn.type}`}
                      onClick={() => {
                        if (btn.label === "Start Building on Dentulu") {
                          navigate('/signup');
                        } else if (btn.label === "View Docs") {
                          window.open(process.env.REACT_APP_API_DOCS_URL, '_blank');
                        }
                      }}
                    >
                      {btn.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="features-grid">
              {dentalAppsData.features.map((item, i) => (
                <div key={i} className="feature-card">
                  <img src={item.icon} alt={item.title} />
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= HOW IT WORKS ================= */}
        <section className="howitworks-section">
          <div className="container howitworks-container">
            <div className="howitworks-header">
              <h2 className="howitworks-title">How It Works</h2>
              <p className="howitworks-text">
                A frictionless path from prototype to marketplace.
              </p>
              <div className="howitworks-actions">
                <button className="howitworks-btn primary" onClick={() => navigate('/signup')}>
                  Create Developer Account
                </button>
                <button className="howitworks-btn secondary" onClick={() => window.open(process.env.REACT_APP_API_DOCS_URL, '_blank')}>
                  Read The Docs
                </button>
              </div>
            </div>

            <div className="howitworks-path">
              <img src={curveLine} alt="" className="howitworks-curve" />

              {stepsData.map((step) => (
                <div
                  key={step.id}
                  className={`howitworks-step ${step.position}`}
                >
                  <img src={dotImg} alt="" />
                  <div className="howitworks-content">
                    <h4>{step.title}</h4>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="sdk-section">
          <div className="container sdk-grid">

            {/* LEFT IMAGE */}
            <div className="sdk-image animate-fade">
              <img src={sdkData.image} alt="SDK Dashboard" />

              <div className="sdk-badges">
                {sdkData.badges.map((badge, i) => (
                  <span key={i} className="sdk-badge">
                    {badge}
                  </span>
                ))}
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="sdk-content animate-slide">
              <h2 className="sdk-title">{sdkData.title}</h2>
              <p className="sdk-subtitle">{sdkData.subtitle}</p>

              <div className="sdk-features">
                {sdkData.features.map((item) => (
                  <div key={item.id} className="sdk-feature">
                    <span className="sdk-step">{item.id}</span>
                    <div>
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </section>
        {/* ================= COMMUNITY ================= */}
        <section
          className="community-section"
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >
          <div className="container">
            <h2 className="community-title">What Our Community Says</h2>
            <p className="community-subtitle">
              Hear from dental providers and developers who are part of our ecosystem
            </p>

            <img
              src={bannerImg}
              alt="Community"
              className="testimonial-banner"
            />

            <div className="testimonial-box">
              <p className="testimonial-text">“{testimonials[active].text}”</p>
              <h4 className="testimonial-name">— {testimonials[active].name}</h4>
              <span className="testimonial-role">{testimonials[active].role}</span>
            </div>

            <div className="testimonial-controls">
              <button onClick={() =>
                setActive((active - 1 + testimonials.length) % testimonials.length)
              }>
                ‹
              </button>
              <button onClick={() =>
                setActive((active + 1) % testimonials.length)
              }>
                ›
              </button>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default DentalApps;
